export function parseHubHandoff(hash: string) {
	const params = new URLSearchParams(hash.replace(/^#/, ''));
	if (!params.has('handoff')) return null;
	const redirect = params.get('redirect');
	return {
		token: params.get('handoff') ?? '',
		redirect:
			redirect?.startsWith('/') &&
			!redirect.startsWith('//') &&
			!redirect.includes('\\') &&
			!Array.from(redirect).some((character) => character.charCodeAt(0) <= 32)
				? redirect
				: null,
	};
}
